/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {useState, useRef, useEffect} from 'react'
import {Box, Button} from '@chakra-ui/react'
import {useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'
import {CloseIcon} from '@epmc-mach/accelarator/overrides/app/components/icons'

export default function ErrorMessage() {
    const [dismissed, setDismissed] = useState(false)
    const {tPaymentStep} = useTranslationHelpers()

    const handleClose = () => {
        setDismissed(true)
        const url = new URL(window.location.href)
        url.searchParams.delete('error')
        window.history.replaceState({}, '', url.toString())
    }
    if (dismissed) {
        return null
    }
    return (
        <Box
            border="1px solid red"
            color="red.500"
            padding="15px 30px"
            display="flex"
            fontSize="lg"
        >
            {tPaymentStep?.errorMessage}
            <Button variant="closeIcon" position="static" ml="5px" onClick={handleClose}>
                <CloseIcon height="15px" width="15px" />
            </Button>
        </Box>
    )
}
